import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import {  CodesLayout, ReferencesLayout } from "../Layouts";

function UserDefinedTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const { userDefinedFormLookupsLoad } = props;

    var currentUser = props.oidc.user;
    const formRefs = useRef({});

    const handleCodesFormLoad = useCallback(() => {
       userDefinedFormLookupsLoad(formRefs)
    }, []);
    const handleRefrencesFormLoad = useCallback(() => {

    }, []);

    const handleFieldChange = useCallback((name, value, e) => {
    }, []);



    return (

        <TabPanel className="TabpanelContainer">
            <TabItem title="Codes">
                <FormField
                    currrentUser={currentUser}
                    layoutId='0BBA5203-687D-4227-B17C-3B711B7F94BF'
                    layoutName='CarrierDataEntryUserDefinedCodesTab'
                    defaultFormSchema={CodesLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={handleFieldChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    onFormLoad={handleCodesFormLoad}
                />
            </TabItem>
            <TabItem title="Refrences">
                <FormField
                    currrentUser={currentUser}
                    layoutId='4E8038F2-1839-4543-BB32-93EC6A74FDC6'
                    layoutName='CarrierDataEntryUserDefinedRefTab'
                    defaultFormSchema={ReferencesLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={handleFieldChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    onFormLoad={handleRefrencesFormLoad}
                />
            </TabItem>
        </TabPanel>

    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(UserDefinedTab);
